import React, { Fragment, useEffect, useRef, useState } from "react";
import {
    Dialog,
    Typography,
    Slide
} from "@material-ui/core";
import { AiOutlineArrowLeft, AiOutlinePrinter } from "react-icons/ai";
import ReactToPrint from 'react-to-print';

import Loading from "../../../../Components/Loading";
import LoadingButton from "../../../../Components/LoadingButton";
import DadosEspelho from "./DadosEspelho";

import { buscarEspelho } from "../../../../Store/Actions/API/restituicaoActions";
import { formataCpf } from "../../../../Utils/utils";
import { useStyles } from "./styles";

export default function DrawerEspelhoPerdcomp({ open, fechar, resultadoSelecionado = {}, cpf = '', nome = '' }) {

    const classes = useStyles();
    const printRef = useRef(null);

    const [loading, setLoading] = useState(false);
    const [dadosEspelho, setDadosEspelho] = useState({});

    useEffect(() => {
        if (resultadoSelecionado.competencia) {
            lidarListagemEspelho();
        } else {
            fechar();
        }
    }, [resultadoSelecionado]) // eslint-disable-line

    const lidarListagemEspelho = async () => {
        const filtros = {
            cpf,
            competencia: resultadoSelecionado.competencia
        };

        setLoading(true);

        const response = await buscarEspelho(filtros);

        if (response !== null) {
            setDadosEspelho({ ...response });
        }

        setLoading(false);
    }

    return (
        <Dialog
            fullScreen
            className={classes.dialog}
            open={open}
            onClose={fechar}
            BackdropProps={{ style: { opacity: 0 } }}
            TransitionComponent={Transition}
        >
            <Fragment>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ padding: 20, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <div onClick={fechar} className={classes.backButton}>
                            <AiOutlineArrowLeft size={18} />
                        </div>
                        <div style={{ marginLeft: 16 }}>
                            <Typography style={{ fontWeight: 700, fontSize: 14 }}>{nome}</Typography>
                        </div>
                        <div style={{ marginLeft: 12 }}>
                            <Typography style={{ fontWeight: 400, fontSize: 14 }}>{formataCpf(cpf)}</Typography>
                        </div>
                        <div style={{ marginLeft: 12 }}>
                            <Typography style={{ fontWeight: 400, fontSize: 14 }}>{'Competência: ' + (resultadoSelecionado.competencia ?? "xx/xxxx")}</Typography>
                        </div>
                        <div style={{ flexGrow: 1 }} />

                        <div style={{ marginRight: 12 }}>
                            <ReactToPrint
                                documentTitle={`EspelhoPerdcomp-${nome}-${cpf}`}
                                trigger={() => {
                                    return <LoadingButton
                                        id="button_imprimir"
                                        variant="contained"
                                        color="primary"
                                        startIcon={<AiOutlinePrinter color={'#000000'} />}
                                        size={'small'}
                                        style={{ color: '#000000' }}
                                    >
                                        Imprimir
                                    </LoadingButton>
                                }}
                                content={() => printRef.current}
                            />
                        </div>
                    </div>
                    {/* Componente utilizado para renderizar a tela*/}
                    {!loading &&
                        <DadosEspelho
                            modoImprimir={false}
                            dadosEspelho={dadosEspelho}
                        />
                    }
                    {/* Componente utilizado para a impressão da tela */}
                    <div style={{ display: 'none' }}>
                        {!loading &&
                            <div ref={printRef}>
                                <DadosEspelho
                                    modoImprimir={true}
                                    cpf={cpf}
                                    nome={nome}
                                    resultadoSelecionado={resultadoSelecionado}
                                    dadosEspelho={dadosEspelho} />
                            </div>
                        }
                    </div>
                </div>

                {loading ? <Loading text={"Carregando dados do espelho..."} /> : null}
            </Fragment>
        </Dialog>
    );
}

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
});

